export default __webpack_public_path__ + "static/media/MILAN.02ce4b0c.png";